import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=35df1a6c&scoped=true"
import script from "./pdfViewer.vue?vue&type=script&lang=js"
export * from "./pdfViewer.vue?vue&type=script&lang=js"
import style0 from "./pdfViewer.vue?vue&type=style&index=0&id=35df1a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df1a6c",
  null
  
)

export default component.exports